export default __webpack_public_path__ + "./images/bonusMoney.303d75f7.svg";